module.exports = __webpack_public_path__ + "static_pc/img/int04.276f1668.png";